import { ReactElement } from 'react'
import getMFEConfig from 'helpers/getMFEConfig'
import { statementsModalContainerId } from 'const/modalContainerId'
import useProfileNavigate from 'hooks/useProfileNavigate'
import StatementsMFE from 'statements-mfe'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import { useAtom, useAtomValue } from 'jotai'
import { triggerOnCloseAnalytics } from 'helpers/triggerOnCloseAnalytics'

const StatementsModal = (): ReactElement => {
  const [{ modalId }, updateModalStatus] = useAtom(modalStatusAtom)
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const statementDetailConfig = getMFEConfig('mfe')

  const { handleProfileClick } = useProfileNavigate()

  const handleCloseModal = (skipAnalytics?: boolean) => {
    updateModalStatus('', '')
    if (!skipAnalytics) {
      triggerOnCloseAnalytics()
    }
  }

  return (
    <StatementsMFE
      config={statementDetailConfig}
      containerId={statementsModalContainerId()}
      selectedAccountId={selectedAccount}
      isModalOpen={modalId === 'Statement'}
      handleClose={handleCloseModal}
      handleProfileClick={handleProfileClick}
    />
  )
}

export default StatementsModal
